<!--
@Author: Calvin Green <calvin>
@Date:   2022-01-11T13:51:01+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-02-01T10:43:40+02:00
@Copyright: Diversitude 2021
-->



<template>
    <Layout>
        <b-row>
            <b-col xl="2" lg="3" md="3" sm="3">
                <keep-alive>
                    <Menu @back="handleBack"/>
                </keep-alive>
            </b-col>
            <b-col xl="10" lg="9" md="9" sm="9">
                <Facility/>
            </b-col>
        </b-row>
    </Layout>
</template>

<script>
import Menu from '@/components/widgets/green-menu.vue'
import Layout from "../../layouts/main-stripped";
import Facility from '@/components/client_admin/facility/facility.vue'
import {layoutMethods} from '@/state/helpers';
export default {
    data:() => ({}),
    components:{
        Layout,
        Menu,
        Facility,
    },
    computed: {
        
    },
    methods: {
        ...layoutMethods,
        handleBack(){
            /*this.showDocumentsMenu();
            this.isEditing = false;
            this.isEditingClient = false;
            this.showStats = false;
            this.showDistribution = false;*/
        },
    },
    mounted(){
        this.$nextTick(()=>{
            //* Tell the green menu component what menu needs to be shown
            this.updateMenuType({
                type: 'clientadmin_facility',
                showMenu: true,
                showRoutes: false,
            })
        })
    },
    beforeDestroy(){
        this.updateMenuType({
            type: 'Nothing',
            showMenu: true,
            showRoutes: false,
        })
    },
}
</script>

<style>

</style>
